import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { uiText, useUiLanguage } from '@/i18n/interface';
import { hasLifetimeAccess } from '../../supabase/functions/_shared/lifetime-access';

export default function SubscriptionSettings() {
  useUiLanguage();
  const { profile } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [scheduled, setScheduled] = useState(false);
  if (profile?.role !== 'admin') return null;
  const free = hasLifetimeAccess(profile.dojo_id);
  async function openPortal() {
    setBusy(true); setError(false);
    try {
      const { data, error } = await supabase.functions.invoke('subscription-portal');
      if (!error && data?.cancellationScheduled) { setScheduled(true); setBusy(false); return; }
      if (error || !data?.url) throw new Error('Portal unavailable');
      const url = new URL(data.url);
      if (url.protocol !== 'https:' || url.hostname !== 'billing.stripe.com') throw new Error('Invalid portal URL');
      window.location.assign(url.href);
    } catch { setError(true); setBusy(false); }
  }
  return <Card><CardHeader><CardTitle>{uiText('Subscription')}</CardTitle></CardHeader><CardContent className="space-y-4">
    {free ? <p>{uiText('Lifetime free access')}</p> : <>
      <p className="text-muted-foreground">{uiText('Cancel renewal securely in Stripe. Cancellation takes effect at the end of your current billing period.')}</p>
      <p className="text-sm text-muted-foreground">{uiText('Only the administrator who pays for this subscription can manage it.')}</p>
      <Button variant="outline" disabled={busy || scheduled} onClick={openPortal}>{busy ? uiText('Opening Stripe...') : uiText('Cancel subscription')}</Button>
      {scheduled && <p role="status">{uiText('Cancellation is already scheduled in Stripe.')}</p>}
      {error && <p role="alert" className="text-destructive">{uiText('Unable to open subscription management. Please contact support.')}</p>}
    </>}
  </CardContent></Card>;
}
